export default {
  hideSubmenu: {
    id: 'hide_submenu',
    defaultMessage: 'Hide submenu for "{title}"',
  },
  showSubmenu: {
    id: 'show_submenu',
    defaultMessage: 'Show submenu for "{title}"',
  },
  mainNavigationAriaLabel: {
    id: 'nav_menu_main_navigation_aria_label',
    defaultMessage: 'Main navigation',
  },
}
